import { KEEP_THE_SAME } from './../../utils/common';
import * as ClientServices from 'services/api/client';
import { ThemesModeEnum } from 'config';
import { Dispatch } from 'react';
import { IAction, IActionMethods, StateStatus } from '../../utils/common';
import * as Types from './types';
import { IFetchGlobalSearchListInput } from 'services/api/globalsearch';
import * as GlobalSearchServices from 'services/api/globalsearch';
import * as Customer_NotificationsService from 'services/api/customer_notifications';

class FetchInterest implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_INTEREST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_INTEREST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_INTEREST,
      status: StateStatus.Failed,
      data: KEEP_THE_SAME,
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await ClientServices.fetchInterest();
        dispatch(this.onSuccess(response.data));
      } catch (error) {
        console.log('Fetch interest Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchGlobalSearch implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_GLOBAL_SEARCH,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_GLOBAL_SEARCH,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_GLOBAL_SEARCH,
      status: StateStatus.Failed,
      data: KEEP_THE_SAME,
    };
  }

  action(payload: IFetchGlobalSearchListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await GlobalSearchServices.fetchGlobalSearchList(
          payload
        );
        dispatch(this.onSuccess(response.data));
      } catch (error) {
        console.log('fetchGlobalSearchList Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface FetchCustomer_NotificationsListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
}

class FetchCustomer_NotificationsList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_CUSTOMER_NOTIFICATIONS_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_CUSTOMER_NOTIFICATIONS_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_CUSTOMER_NOTIFICATIONS_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: FetchCustomer_NotificationsListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response =
          await Customer_NotificationsService.fetchCustomer_NotificationsList(
            payload
          );
        dispatch(this.onSuccess(response.data));
      } catch (error) {
        console.log('FetcCustomer_NotificationsList Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}
interface EditCustomer_NotificationsInput {
  id: number | null;
  template: number | null;
  subject: string | null;
  body: string | null;
  email: string | null;
  notification: string | null;
  emailrecepient: string | null;
  customerid: number | null;
  viewed: number | null;
  datesend: string | null;
  url: string | null;
  web: string | null;
  fetchCustomer_NotificationsInput: FetchCustomer_NotificationsListInput;
}

class EditCustomer_Notifications implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_EDIT_CUSTOMER_NOTIFICATIONS,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_EDIT_CUSTOMER_NOTIFICATIONS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_EDIT_CUSTOMER_NOTIFICATIONS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: EditCustomer_NotificationsInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        const { fetchCustomer_NotificationsInput, ...rest } = payload;

        dispatch(this.onPending());
        let response =
          await Customer_NotificationsService.editCustomer_Notifications(
            payload
          );
        dispatch(this.onSuccess(response.data));
        dispatch(
          new FetchCustomer_NotificationsList().action(
            fetchCustomer_NotificationsInput
          )
        );
      } catch (error) {
        console.log('EditNotification Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      } finally {
        // add something
      }
    };
  }
}

export default {
  fetchInterestAction: () => new FetchInterest().action(),
  fetchGlobalSearchAction: (payload: IFetchGlobalSearchListInput) =>
    new FetchGlobalSearch().action(payload),
  fetchCustomer_NotificationsListAction: (
    payload: FetchCustomer_NotificationsListInput
  ) => new FetchCustomer_NotificationsList().action(payload),
  editCustomer_NotificationsAction: (
    payload: EditCustomer_NotificationsInput
  ) => new EditCustomer_Notifications().action(payload),
};
